import { ProcessingTime } from '../../domain/ProcessingTime';
import type { CalculationTacticStepsExecutionTimes } from '../../index';
import type {
  ProcessingTimeState,
  CalculationSetStatistics
} from './CalculationSetStatistics.types';

export class CalculationTacticProcessingTimes {
  private executionTimes: CalculationTacticStepsExecutionTimes;
  private constructor(executionTimes: CalculationTacticStepsExecutionTimes) {
    this.executionTimes = executionTimes;
  }

  static fromExecutionTimes(
    executionTimes: CalculationTacticStepsExecutionTimes
  ) {
    return new CalculationTacticProcessingTimes(executionTimes);
  }

  private getCalculationProcessingTimeState(): ProcessingTimeState {
    return this.executionTimes?.calculations
      ? {
          type: 'PROCESSING_TIME_AVAILABLE',
          processingTime: ProcessingTime.fromTimeInterval(
            new Date(this.executionTimes.calculations.startTime),
            new Date(this.executionTimes.calculations.endTime)
          )
        }
      : { type: 'NO_PROCESSING_TIME' };
  }

  private getContainmentProcessingTimeState(): ProcessingTimeState {
    return this.executionTimes?.gettingContainment
      ? {
          type: 'PROCESSING_TIME_AVAILABLE',
          processingTime: ProcessingTime.fromTimeInterval(
            new Date(this.executionTimes.gettingContainment.startTime),
            new Date(this.executionTimes.gettingContainment.endTime)
          )
        }
      : { type: 'NO_PROCESSING_TIME' };
  }

  private getTopologyProcessingTimeState(): ProcessingTimeState {
    return this.executionTimes?.gettingTopology
      ? {
          type: 'PROCESSING_TIME_AVAILABLE',
          processingTime: ProcessingTime.fromTimeInterval(
            new Date(this.executionTimes.gettingTopology.startTime),
            new Date(this.executionTimes.gettingTopology.endTime)
          )
        }
      : { type: 'NO_PROCESSING_TIME' };
  }

  asProcessingTimes(): CalculationSetStatistics['processingTimes'] {
    return {
      calculation: this.getCalculationProcessingTimeState(),
      gridContainmentRetrieval: this.getContainmentProcessingTimeState(),
      gridDataRetrieval: this.getTopologyProcessingTimeState()
    };
  }
}
